const ShimmerBox = ({ className }) => (
  <div className={`relative overflow-hidden shimmer rounded ${className}`}>
    <div className="absolute inset-0 -translate-x-full animate-shimmer bg-gradient-to-r from-gray-200 via-gray-300 to-gray-200" />
  </div>
);

const PersonalShimmer = () => {
  return (
    <section className="relative max-w-7xl mx-auto px-4 md:px-6 py-4 space-y-10">
      {/* HEADER */}
      <div className="flex items-center justify-between bg-white px-6 py-4 rounded-2xl shadow-sm">
        <ShimmerBox className="h-8 w-8 rounded-full" />
        <ShimmerBox className="h-6 w-40 rounded-md" />
        <div className="w-10" />
      </div>

      {/* PROFILE CARD */}
      <div className="mt-10 bg-white border rounded-3xl p-8 text-center shadow-sm">
        <div className="flex flex-col items-center">
          <ShimmerBox className="w-36 h-36 rounded-full" />
          <ShimmerBox className="mt-4 h-5 w-40 rounded-md" />
          <ShimmerBox className="mt-2 h-4 w-56 rounded-md" />
          <ShimmerBox className="mt-4 h-4 w-72 rounded-md" />
        </div>
      </div>

      {/* FORM CARD */}
      <div className="bg-white border rounded-3xl p-6 md:p-8 shadow-sm">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-10">
          {/* LEFT */}
          <div className="space-y-5">
            <ShimmerBox className="h-10 w-full rounded-lg" />
            <ShimmerBox className="h-10 w-full rounded-lg" />
            <div className="flex gap-3">
              <ShimmerBox className="h-10 w-32 rounded-lg" />
              <ShimmerBox className="h-10 w-full rounded-lg" />
            </div>
          </div>

          {/* RIGHT AVATARS */}
          <div>
            <ShimmerBox className="h-4 w-32 mb-4 rounded-md" />
            <div className="grid grid-cols-4 gap-3">
              {Array.from({ length: 8 }).map((_, i) => (
                <ShimmerBox key={i} className="w-20 h-20 rounded-xl" />
              ))}
            </div>
          </div>
        </div>

        {/* ACTIONS */}
        <div className="mt-10 pt-6 border-t flex justify-between">
          <ShimmerBox className="h-5 w-40 rounded-md" />
          <ShimmerBox className="h-10 w-40 rounded-full" />
        </div>
      </div>
    </section>
  );
};

export default PersonalShimmer;
